import React, { useState, useEffect } from 'react'
import { Modal } from '../../../../UI/Modal/Modal.component';
import { Form, Input, Space, Button, Row, Radio, Select, Typography } from 'antd';
import { SaveOutlined } from '@ant-design/icons';
import { DeviceRestrictedInput } from '../DeviceRestrictedInput.component';
import { findDevice, saveAAPNetworkSettings } from '../../../../../services/StationService';
import { useNotificationApi } from '../../../../UI/NotificationProvider';

const { Option } = Select;
const { Text } = Typography;

const HelperText = ({text}) => {
    return (
        <div style={{color: '#888', fontSize: 12}}>
            <p>{text}</p>
        </div>
    )
}

export const AAPNetworkSettingsModal = ({stationID, listAAP, device, displayModal, setDisplayModal, ...props}) => {

    const notificationApi = useNotificationApi();

    const [form] = Form.useForm();
    const [encryptionMode, setEncryptionMode] = useState('');
    const [initialValues, setInitialValues] = useState(null);
    const [errorMessage, setErrorMessage] = useState(false);

    useEffect(() => {
        form.resetFields();
    }, [])

    useEffect(() => {
        let data = {
            id: device.id, 
            stationID: stationID 
        }

        findDevice(data).then((response) => {
            if(response){
                setInitialValues(response?.data)
                form.setFieldsValue(response?.data)
            } else{
                setInitialValues(device)
            }
        })
    }, [])

    const networkSettingsHandler = (values) => {
        let data = {
            serialNum: device.serialNum, 
            stationID: stationID,
            ...values
        }
        
        saveAAPNetworkSettings(data).then((response) => {
            if(response.result){
                notificationApi.success({
                    message: 'Network Settings Updated', 
                    description: `AAP - Serial Number: ${data.serialNum} has been successfully updated.`,
                })
                setDisplayModal(false)
            } else {
                notificationApi.error({
                    message: 'Error', 
                    description: 'Failed to update network settings. Please try again.'
                })
            }
        })
    }

    return (
        <>
            <Modal
                visible={displayModal}
                setVisible={setDisplayModal}
                title='Network Settings'
                justifyTitle='middle'
                actionGroup={false}
                width={450}
                >
                <Form
                    name={`AAP-${device.id}-network-settings-form`}
                    form={form}
                    layout='vertical'
                    initialValues={{
                        ...initialValues, 
                        encryptionMode: 'unchanged'
                    }}
                    onValuesChange={() => setErrorMessage(false)}
                    onFinish={(values) => networkSettingsHandler(values)}
                    >
                    <DeviceRestrictedInput label="Network Name:" name="networkName" >
                        <Input placeholder='Enter network name'/>
                    </DeviceRestrictedInput>
                    <Form.Item label="Frequency:" name="frequency">
                        <Select placeholder="Select frequency">
                            <Option value="1">1</Option>
                            <Option value="2">2</Option>
                            <Option value="3">3</Option>
                            <Option value="4">4</Option>
                            <Option value="5">5</Option>
                            <Option value="6">6</Option>
                            <Option value="7">7</Option>
                            <Option value="8">8</Option>
                        </Select>
                    </Form.Item>
                    <Form.Item 
                        label='Encryption Mode:'
                        name='encryptionMode' 
                        value={encryptionMode}
                        rules={[
                            { required: true, message: 'Encryption mode is required' }
                        ]}
                        >
                        <Radio.Group onChange={(e) => setEncryptionMode(e.target.value)} value={encryptionMode}>
                            <Space direction='vertical' size='small'>
                                <Radio value='custom'>Custom encryption</Radio>
                                <Radio value='random'>Generate a random encryption</Radio>
                                {listAAP?.length > 1 && 
                                    <Radio value='copy-encryption'>Copy encryption from another AAP</Radio>
                                }
                                <Radio value='unchanged'>
                                    Keep existing encryption
                                    <HelperText text='No changes will be made to the current encryption'/>
                                </Radio>
                            </Space>
                        </Radio.Group>
                    </Form.Item>
                    { encryptionMode === 'custom' && (
                        <DeviceRestrictedInput
                            label='Encryption:'
                            name='customEncryption'
                            >
                            <Input.Password showCount/>
                        </DeviceRestrictedInput>
                    )}
                    { encryptionMode === 'copy-encryption' && (
                        <Form.Item 
                            label='AvaLAN Access Point:' 
                            name='aap'
                            rules={[
                                { required: true, message: 'Please select a device' }
                            ]}
                            >
                            <Select placeholder='Select serial number'>
                                {listAAP
                                    .filter(aap => device.id !== aap.id)
                                    .map(aap => (
                                    <Option key={aap.id} value={aap.id}>{aap.serialNum}</Option>
                                ))}
                            </Select>
                        </Form.Item>
                    )}
                    
                    { errorMessage &&
                        <Row style={{marginBottom: 12, marginTop: -6}}>
                            <Text type='danger'>{errorMessage}</Text>
                        </Row>
                    }

                    <Row justify='end'>
                        <Space>
                            <Button onClick={() => setDisplayModal(false)}>Cancel</Button>
                            <Button type='primary' icon={<SaveOutlined/>} htmlType='submit'>Save</Button>
                        </Space>
                    </Row>
                </Form>
            </Modal>
        </>
    )
}